import {Dispatch, SetStateAction, useState} from 'react';

import {httpIncidentAPI} from 'features/http/api/httpIncidentAPI';
import IOrderBy from 'shared/model/IOrderBy';
import IPagination from 'shared/api/model/IPagination';
import {getPollingInterval} from 'shared/api/pollingHelper';

import IHttpIncident from './HttpIncident/IHttpIncident';

export interface IUseHttpMonitorIncidents {
    pagination: IPagination<IHttpIncident> | undefined,
    isLoading: boolean,
    isFetching: boolean,
    sort: IOrderBy | undefined,
    setSort: Dispatch<SetStateAction<IOrderBy | undefined>>,
    setPage: Dispatch<SetStateAction<number>>,
}

export const useHttpMonitorIncidents = (monitorId: string): IUseHttpMonitorIncidents => {
    const [sort, setSort] = useState<IOrderBy>();
    const [page, setPage] = useState(1);

    const {data: pagination, isLoading, isFetching} = httpIncidentAPI.useGetHttpIncidentsQuery(
        {monitorId, page, sort},
        {pollingInterval: getPollingInterval()},
    );

    return {pagination, isLoading, isFetching, sort, setSort, setPage};
};

export default useHttpMonitorIncidents;
